import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solero',
  templateUrl: './solero.component.html',
  styleUrls: ['./solero.component.scss']
})
export class SoleroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
